import { findPath } from './findPath';

/**
 * Compute a multi-stop route by chaining pathfinding between consecutive stops.
 * Only computes path segments where BOTH stops are on the specified floor.
 *
 * @param {Array} roundedPaths - Path network for current floor
 * @param {Array} stops - ALL stops in original order, each with { center, floorIndex, ... }
 * @param {number} currentFloor - The active floor index to render paths for
 * @returns {{ segments: Array, allPoints: Array }}
 */
export function computeMultiStopRoute(roundedPaths, stops, currentFloor) {
	if (!roundedPaths || !stops || stops.length < 2) {
		return { segments: [], allPoints: [] };
	}

	const segments = [];

	for (let i = 0; i < stops.length - 1; i++) {
		const fromStop = stops[i];
		const toStop = stops[i + 1];

		// Only compute path when both consecutive stops are on the current floor
		if (fromStop.floorIndex !== currentFloor || toStop.floorIndex !== currentFloor) continue;

		const result = findPath(roundedPaths, fromStop.center, toStop.center);
		if (result && result.path) {
			segments.push({
				path: result.path,
				startPoint: result.startPoint,
				endPoint: result.endPoint,
				fromIndex: i,
				toIndex: i + 1,
			});
		}
	}

	// Concatenate all path points (removing duplicate junction points)
	const allPoints = [];
	segments.forEach((seg, i) => {
		if (i === 0) {
			allPoints.push(...seg.path);
		} else {
			allPoints.push(...seg.path.slice(1));
		}
	});

	return { segments, allPoints };
}
